/**
 * ModeSwitch Component
 *
 * Toggle buttons for switching between Quick and Detailed modes
 * Pill-style button group with active state highlighting
 */

import React from 'react';
import type { ModeSwitchProps } from '../types/forge';
import styles from '../styles/forge.module.css';

export const ModeSwitch: React.FC<ModeSwitchProps> = ({
  currentMode,
  onChange,
  disabled = false,
}) => {
  return (
    <div className={styles.modeSwitch} role="tablist" aria-label="FORGE Mode">
      <button
        role="tab"
        aria-selected={currentMode === 'quick'}
        aria-controls="quick-mode-panel"
        className={`${styles.modeSwitchButton} ${
          currentMode === 'quick' ? styles.modeSwitchButtonActive : ''
        }`}
        onClick={() => onChange('quick')}
        disabled={disabled}
      >
        Quick Mode
      </button>
      <button
        role="tab"
        aria-selected={currentMode === 'detailed'}
        aria-controls="detailed-mode-panel"
        className={`${styles.modeSwitchButton} ${
          currentMode === 'detailed' ? styles.modeSwitchButtonActive : ''
        }`}
        onClick={() => onChange('detailed')}
        disabled={disabled}
      >
        Detailed Mode
      </button>
    </div>
  );
};

export default ModeSwitch;
